
import axios from '../wmsAxios'

// 保存
export const save = (data) => {
    return axios({
        url: '/tOrderDetail/save',
        method: 'post',
        data
    })
}

// 删除
export const batchDelete = (data) => {
    return axios({
        url: '/tOrderDetail/delete',
        method: 'post',
        data
    })
}

// 查询分页数据
export const findPage = (data) => {
    return axios({
        url: '/tOrderDetail/findPage',
        method: 'post',
      data
    })
}

// 查询重复的行号
export const findDuplicateLine = (data) => {
  return axios({
    url: '/tOrderDetail/findDuplicateLine',
    method: 'post',
    data
  })
}



// WEBPACK FOOTER //
// ./src/http/moudules/tOrderDetail.js